var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ManagePageContainer',{attrs:{"id":"ManageNormalCompleted"}},[_c('div',[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }